const urls = {
    encryptUrl: 'https://patient-uat.kfsyscc.org/vender/api/paymentPhe/Encrypt',
    authlogUrl: 'https://patient-uat.kfsyscc.org/vender/api/paymentPhe/Authlog',
    sslAuth: 'https://testepos.ctbcbank.com/mauth/SSLAuthUI.jsp'
}

let MerID = '77507'

if (process.env.REACT_APP_ENV === 'PRODUCTION') {
    urls.encryptUrl = 'https://patient.kfsyscc.org/vender/api/paymentPhe/Encrypt'
    urls.authlogUrl = 'https://patient.kfsyscc.org/vender/api/paymentPhe/Authlog'
    urls.sslAuth = 'https://epos.ctbcbank.com/mauth/SSLAuthUI.jsp'
    MerID = '3001'
}

export { urls, MerID }
